import { FC, useMemo } from 'react';
import { Form, Tabs } from 'antd';
import { ActionEntityType, UserRoleType } from '@pmp/api';
import { useTranslation } from 'react-i18next';
import { CrudMode } from '@ohpen/enso-ui';

import { FormSchemaProps } from '../interfaces';
import { BrokerDetailsTab, NotesTab, AssistantsTab, AdvisersTab } from '.';

export const BrokersFormSchema: FC<FormSchemaProps> = ({ form, mode, selectsOptions }) => {
  const { t } = useTranslation();
  const entityType = ActionEntityType.BROKERS;

  const watchedRoles = Form.useWatch('roles') as UserRoleType[] | undefined;
  const isAdvisor = watchedRoles?.includes(UserRoleType.ADVISOR) ?? false;
  const isAssistant = watchedRoles?.includes(UserRoleType.ASSISTANT) ?? false;
  const isSupervisor = watchedRoles?.includes(UserRoleType.SUPERVISOR) ?? false;

  const items = useMemo(
    () => [
      {
        key: 'broker-details',
        label: t('lender.brokers.labels.brokerDetails'),
        children: <BrokerDetailsTab form={form} mode={mode} selectsOptions={selectsOptions} />,
      },
      ...(isAdvisor || isSupervisor
        ? [
          {
            key: 'assistants',
            label: t('lender.brokers.labels.assistants'),
            children: <AssistantsTab form={form} mode={mode} selectsOptions={selectsOptions} />,
          },
        ]
        : []),
      ...(isAssistant || isSupervisor
        ? [
          {
            key: 'advisers',
            label: t('lender.brokers.labels.advisers'),
            children: <AdvisersTab form={form} mode={mode} selectsOptions={selectsOptions} />,
          },
        ]
        : []),
      ...(CrudMode.CREATE === mode
        ? []
        : [{
          key: 'notes',
          label: t('lender.brokers.labels.notes'),
          children: <NotesTab form={form} mode={mode} selectsOptions={selectsOptions} entityType={entityType} />,
        }]),
    ],
    [form, mode, selectsOptions, t, entityType, isAdvisor, isAssistant, isSupervisor],
  );

  return (
    <div className="enso-ui-tabs-wrapper">
      <Tabs items={items} />
    </div>
  );
};
